module.exports = __webpack_public_path__ + "img/p70.556b192f.png";